import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import winSatsIcon from '../images/congratsIcon1.png';
import TimerIcon from '../images/timer.png';
import Modal from "react-modal";
import { BsShareFill } from "react-icons/bs";
import { HiXMark } from "react-icons/hi2";
import * as nativeEvents from '../Helper/native';
import * as APIHelper from '../Helper/apiFetch';
import Lottie from "lottie-react";
import CongLottie from '../../src/lottie.json';
Modal.setAppElement("#root");

const initiaData = require('./urlEncodeTest.json');

const Congratulation = ({ title, discountCode, cardType, quiz=true, rewardType, onAction }) => {
    const [modal, setModal] = useState(true);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [timeLeft, setTimeLeft] = useState(5);

    const navigateHome = () => {
        setModal(false);
        nativeEvents.goHistory();
        /* if(onAction) {
            onAction();
        } else {
            switch(rewardType) {
                case "card_percentage":
                case "card_upgrade":
                case "txn_satspay":
                case "txn_bbps":
                    nativeEvents.goBack();
                    break;
                case "txn":
                    nativeEvents.shopNow();
                    break;
                case "card_load":
                    nativeEvents.loadCard();
                    break;
                case "card_purchase":
                    nativeEvents.purchaseCard();
                    break;
                case "card_activate":
                    nativeEvents.activateCard();
                    break;
                default:
                    nativeEvents.goHistory();
                    break;
            }
            window.location.reload();
        } */
    }

    const shareWithFriends = () => {
        nativeEvents.shareWithFriends(initiaData.popUpShareMessage.msg);
        if(onAction) {
            onAction();
        }
    }

    useEffect(() => {
        setIsOpen(true);
        
        // Auto-close timer
        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigateHome();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            clearInterval(timer);
            setModal(false);
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [])

    /*  const getCard = (code) => {
         nativeEvents.purchaseCard(code);
     } */

    useEffect(() => {
        if (modal) {
            document.body.classList.add('active-model')
            document.body.style.overflow = 'hidden'
        } else {
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [modal])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: CongLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const getCard = () => {
        const toastMessage = document.getElementById("toastMessage");
        navigator.clipboard.writeText(discountCode);
        showToast(toastMessage);
    }

    function showToast(toastMessage) {
        toastMessage.classList.add("show");
        setTimeout(() => {
            nativeEvents.purchaseCard(discountCode);
            toastMessage.classList.remove("show");
        }, 2000);
    }

    return (
        <div >
            {modal && (
                <Modal
                    isOpen={isOpen}
                    closeTimeoutMS={500}
                    className="mymodal"
                    contentLabel="My dialog"
                    overlayClassName="myoverlay"
                >
                    <div className='cong'>
                        {/* Close icon for merchant popup */}
                        {/* {title?.doneButton === "Shop Now" && ( */}
                            {/* <button
                                onClick={navigateHome}
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10
                                }}
                            >
                                <HiXMark size={24} color="#000000" />
                            </button> */}
                        {/* )} */}
                        <div className='cong-Subcontainer'>
                            <div style={{
                                position: 'absolute',
                                top: '-15px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '14px',
                                color: '#000000',
                                fontWeight: '600',
                                zIndex: 10,
                                backgroundColor: '#FFFFFF',
                                padding: '5px 10px',
                                borderRadius: '100px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '5px'
                            }}>
                                <div>
                                    <img src={TimerIcon} alt='Timer' style={{ width: '18px', height: '18px' }} /> <span style={{ fontSize: '14px', fontWeight: '600', color: '#000000' }}>{timeLeft}s</span>
                                </div>
                            </div>
                            <div style={{ position: 'relative', paddingTop: '20px' }}>
                                <h1
                                    className='cong-title'
                                    style={{
                                        color: title?.titleColor || '#0021A5',
                                        paddingTop: '20px',
                                        marginBottom: '16px'
                                    }}
                                >
                                    {title?.title}
                                </h1>
                                <p className='cong-subTitle' dangerouslySetInnerHTML={{ __html: title?.msg1 }} />
                                
                                {/* Buttons container */}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px',
                                    marginTop: '24px',
                                    width: '100%'
                                }}>
                                    <button
                                        className='cong-HomeButn'
                                        onClick={navigateHome}
                                        style={{
                                            width: '100%',
                                            background: 'linear-gradient(90deg, #FFAA44 0%, #E57D00 100%, #FFAA44 100%)',
                                            color: '#FFFFFF',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            padding: '12px',
                                            borderRadius: '100px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        VIEW REWARDS
                                    </button>
                                    <button
                                        className='cong-button'
                                        onClick={() => shareWithFriends()}
                                        style={{
                                            width: '100%',
                                            backgroundColor: 'transparent',
                                            color: '#FF631B',
                                            border: '1px solid rgba(255, 99, 27, 0.3)',
                                            padding: '12px',
                                            borderRadius: '100px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        SHARE WITH FRIENDS
                                        <BsShareFill size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className=' cong-container '>
                        <div className='cong' >
                            <div className=' cong-Subcontainer'>
                                {
                                    quiz === false ?
                                        null
                                        :
                                        <div className='cong-iplStreak-container'>
                                            <Lottie
                                                options={defaultOptions}
                                                height={250}
                                                width={300}
                                                style={{ marginTop: '-93px' }}
                                            />
                                        </div>
                                }

                                <div style={{ position: 'relative' }}>
                                    <h1 className='cong-title' style={{ color: title?.shareButton === undefined ? '#FB604A' : '#000000', paddingTop: quiz === false ? '20px' : '130px' }}>{title?.title}</h1>
                                    <p className='cong-subTitle' dangerouslySetInnerHTML={{ __html: title?.msg1 }} />
                                    {
                                        quiz === false ?
                                            <div>
                                                <button className='cong-HomeButn' onClick={navigateHome}>{title?.doneButton}</button>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div>
                                    {
                                        quiz === false ?
                                            null
                                            :
                                            <div>
                                                <div className='congDivider'>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div className="congPopUpTitle">
                                                        Share with your friends and earn more!
                                                    </div>
                                                    <div>
                                                        {
                                                            cardType === "undefined" ?
                                                                <div>
                                                                    <button className='cong-button' onClick={() => shareWithFriends()}>{title?.shareButton}<BsShareFill size={16} /></button>
                                                                </div>
                                                                :
                                                                <div>
                                                                    {cardType === "undefined" ? <button className='cong-button' onClick={() => getCard()}>{title?.getCard}</button> : <button className='cong-button' onClick={() => shareWithFriends()}>{title?.shareButton}<BsShareFill size={16} /></button>}
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                            {
                                quiz === false ?
                                    null
                                    :
                                    <div>
                                        {
                                            discountCode != undefined ?
                                                <div>
                                                    <button className='shareCong-button' onClick={() => getCard(discountCode)}>{title?.getCard}</button>
                                                </div>
                                                :
                                                <div>
                                                    <button className='cong-HomeButn mb-4' onClick={navigateHome}>{title?.doneButton}</button>
                                                </div>
                                        }

                                    </div>
                            }
                        </div>
                        <div class="toast" id="toastMessage" style={{width:'maxContent'}}>Coupon Code copied to clipboard</div>
                    </div> */}
                </Modal>
            )}
        </div>
    );
}

export default Congratulation;


